import React, { useState } from 'react';

export const ShopSection = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Product categories with products
  const productTabs = [
    {
      name: 'Pet Food',
      products: [
        {
          id: 1,
          name: 'Royal Canin',
          image: '/images/rc.png',
          details: 'High-quality nutrition for adult dogs'
        },
        {
          id: 2,
          name: 'Pedigree',
          image: '/images/pedigree.png',
          details: 'Specially designed for puppies'
        },
        {
          id: 3,
          name: 'M&K Pet Food',
          image: '/images/MandK.jfif',
          details: 'Balanced nutrition for senior dogs'
        },
        {
          id: 4,
          name: 'Whiskas',
          image: '/images/whiskas.svg',
          details: 'Quality cat food for all breeds'
        }
      ]
    },
    {
      name: 'Pet Toys',
      products: [
        {
          id: 5,
          name: 'Rubber Ball Toy',
          image: '/images/rubberball.webp',
          details: 'Bouncy and durable rubber ball for fetch'
        },
        {
          id: 6,
          name: 'Rope Chew Toy',
          image: '/images/ropetoy.avif',
          details: 'Soft rope toy for interactive play'
        },
        {
          id: 7,
          name: 'Squeaky Plush Toy',
          image: '/images/plush.jfif',
          details: 'Cute plush toy with squeaker inside'
        },
        {
          id: 8,
          name: 'Kong Interactive Toy',
          image: '/images/kong.jfif',
          details: 'Durable toy for mental stimulation'
        }
      ]
    },
    {
      name: 'Accessories',
      products: [
        {
          id: 9,
          name: 'Dog Collar',
          image: '/images/collar.avif',
          details: 'Comfortable and stylish collar'
        },
        {
          id: 10,
          name: 'Leash',
          image: '/images/leash.webp',
          details: 'Durable and strong leash'
        },
        {
          id: 11,
          name: 'Dog Bed',
          image: '/images/dogbed.jpg',
          details: 'Comfortable sleeping bed'
        },
        {
          id: 12,
          name: 'Belt',
          image: '/images/dog belt.jfif',
          details: 'Comfortable and adjustable belt'
        }
      ]
    },
    {
      name: 'Grooming & Care',
      products: [
        {
          id: 13,
          name: 'Dog Shampoo',
          image: '/images/dog shampoo.webp',
          details: 'Gentle and effective shampoo'
        },
        {
          id: 14,
          name: 'Grooming Brush',
          image: '/images/groomingbrush.jfif',
          details: 'Professional grooming brush'
        },
        {
          id: 15,
          name: 'Nail Clippers',
          image: '/images/nail.jfif',
          details: 'Safe and easy nail trimming'
        },
        {
          id: 16,
          name: 'Conditioner',
          image: '/images/conditioner.jpg',
          details: 'Moisturizing coat conditioner'
        }
      ]
    }
  ];

  return (
    <section id="shop" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
              Pet Shop
            </h2>
            <div className="w-24 h-1 bg-yellow-400 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Quality food and accessories available at Raj Canine Care
            </p>
          </div>

          {/* Tabs */}
          <div className="flex flex-wrap justify-center gap-2 mb-12">
            {productTabs.map((tab, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                  activeTab === index
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 border-2 border-blue-200 hover:border-blue-600'
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {productTabs[activeTab].products.map((product) => (
              <div
                key={product.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden"
              >
                {/* Product Image */}
                <div className="w-full h-48 bg-gray-50 flex items-center justify-center overflow-hidden p-4">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/200?text=' + product.name;
                    }}
                  />
                </div>

                {/* Product Info */}
                <div className="p-6">
                  <h3 className="text-lg font-bold text-blue-900 mb-2">
                    {product.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    {product.details}
                  </p>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};